import React from 'react';

export const FieldRiskScore = ({ field }) => {
    const score = parseInt(field.FieldValue, 10);

    let riskClass = "";
    let riskLabel = "";

    if (isNaN(score)) return null;

    if (score <= 20) {
        riskClass = "profiles-risk-low";
        riskLabel = "Low Risk";
    } else if (score <= 50) {
        riskClass = "profiles-risk-moderate";
        riskLabel = "Moderate Risk";
    } else if (score <= 75) {
        riskClass = "profiles-risk-high";
        riskLabel = "High Risk";
    } else {
        riskClass = "profiles-risk-critical";
        riskLabel = "Critical Risk";
    }

    return (
        <div className="profiles-field-row">
            <div className="profiles-field-label">{field.TitleDisplayed}</div>
            <div className="profiles-field-value">
                <span className={`profiles-risk-badge ${riskClass}`}>
                    <strong>{score}</strong> <span className="mx-1">&mdash;</span> {riskLabel}
                </span>
            </div>
        </div>
    );
};

export const CustomFieldRenderers = {
    "RiskScore": FieldRiskScore,
};